/* eslint-disable sorare/no-detached-fragments */
import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import { TokenLoyaltyBoost } from '#src/components/token/Token/TokenLoyaltyBoost/index.tsx';

import type {
  SealingCardsMutation,
  SealingCardsMutationVariables,
} from './__generated__/useSealingMutation.graphql.ts';

const mutation = gql`
  mutation SealingCardsMutation($input: sealCardsInput!) {
    sealCards(input: $input) {
      cards {
        slug
        sealedFor
        ...TokenLoyaltyBoost_anyCard
      }
      errors {
        message
      }
    }
  }
  ${TokenLoyaltyBoost.fragments.anyCard}
` as TypedDocumentNode<SealingCardsMutation, SealingCardsMutationVariables>;

export const useSealingMutation = () => {
  return useMutation(mutation, {
    showErrorsWithSnackNotification: true,
  });
};
